import { create } from 'zustand';
/** The app's signed-in user; the app creates it once, in its session singleton. */
export function createSessionStore(params) {
    const { onClear } = params;
    return create((set) => ({
        user: null,
        setUser: (user) => set({ user }),
        clearSession: () => {
            onClear();
            set({ user: null });
        },
    }));
}
